import React, { useState, useEffect, useRef } from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';
import { InputSwitch } from 'primereact/inputswitch';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Badge } from 'primereact/badge';
import { Tooltip } from 'primereact/tooltip';
import { storage } from '../../helpers/storage';


const initialForm = {
    "DescripcionCicloEscolar": "",
    "LinkVideoTutorial": "",
    "Activo": "",
    "FechaIni": "",
    "FechaFin": "",
    "EntregaKit": "",
    "CantidadEvidencias": "",
    "TextoCiclo": "",
    "VigenciaCiclo": "",
    "LimitePrendas": "",
    "HabilitarEntregaParcial": "",
    "Evento": "",
    "Visible": "",
    "proceso": null,
    "otroProceso": "",
    "evidencias": [""],
    "prendas": [""]
}

// const meses = ["ENE.", "FEB.", "MAR.", "ABR.", "MAY.", "JUN.", "JUL.", "AGO.", "SEP.", "OCT.", "NOV.", "DIC."];

const validationsFrom = (form) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    console.log(form);

    if (!form.DescripcionCicloEscolar.trim()) {
        errors.DescripcionCicloEscolar = "El Campo (Ciclo escolar) es requerido";
    }

    // Validación de límites numéricos
    if (!form.LimitePrendas || form.LimitePrendas === 0) {
        errors.LimitePrendas = "Cant. de prendas no permitido.";
    } else if (form.LimitePrendas < 1) {
        errors.LimitePrendas = "Debe haber al menos 1 prenda";
    }

    if (!form.CantidadEvidencias || form.CantidadEvidencias === 0) {
        errors.CantidadEvidencias = "Cantidad de evidencias no permitido.";
    } else if (form.CantidadEvidencias < 1) {
        errors.CantidadEvidencias = "Debe haber al menos 1 evidencia";
    } else if (form.CantidadEvidencias > 10) {
        errors.CantidadEvidencias = "Máximo 10 evidencias permitidas";
    }

    // Validación de fechas
    if (!form.FechaIni) {
        errors.FechaIni = "El Campo (Fecha inicio) es requerido";
    }

    if (!form.FechaFin) {
        errors.FechaFin = "El Campo (Fecha fin) es requerido";
    }

    // Validación de proceso
    if (!form.proceso) {
        errors.proceso = "El Campo (Proceso) es requerido";
    }

    // Validación de prendas dinámicas
    if (form.prendas && form.prendas.length > 0) {
        form.prendas.forEach((prenda, index) => {
            if (!prenda) {
                errors[`prenda-${index}`] = `La Prenda ${index + 1} es requerida`;
            } else if (typeof prenda === 'object' && prenda.idprenda === 0) {
                // Validar que si es "Otros", el texto no esté vacío
                if (!prenda.Prenda || !prenda.Prenda.trim()) {
                    errors[`prenda-${index}`] = `Debe especificar la prenda ${index + 1}`;
                }
            }
        });
    }

    // Validación de evidencias dinámicas
    if (form.evidencias && form.evidencias.length > 0) {
        form.evidencias.forEach((evidencia, index) => {
            if (!evidencia) {
                errors[`evidencia-${index}`] = `La Evidencia ${index + 1} es requerida`;
            }
            // No validamos el estado 'activo' como error, ya que es opcional desactivar
        });
    }

    return errors;
}

const Edit = ({ visible, user, close, onComponentUpdate }) => {

    const toast = useRef(null);

    const [form, setForm] = useState(initialForm);
    const [initialFormState, setInitialFormState] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [lstProcesos, setLstProcesos] = useState([]);
    const [lstTipoEvidencias, setLstTipoEvidencias] = useState([]);
    const [lstPrendas, setLstPrendas] = useState([]);
    const [showInput, setShowInput] = useState(false);
    const perfil = storage.get("perfilid");
    const usuario = storage.get('id');

    const isValidJsonArrayString = (str) => {
        try {
            const parsedValue = JSON.parse(str);
            return Array.isArray(parsedValue) && parsedValue.length > 0;
        } catch (error) {
            // If JSON.parse() throws an error, the string is not valid JSON.
            return false;
        }
    }

    useEffect(() => {
        if (user != null) {
            const fechaInicioCiclo = user.FechaIni !== null ? new Date(user.FechaIni) : "";
            const fechaFinCiclo = user.FechaFin !== null ? new Date(user.FechaFin) : "";
            const validateproceso = isValidJsonArrayString(user.proceso) ? JSON.parse(user.proceso)[0] : ""
            const validateprendas = isValidJsonArrayString(user.prenda) ? JSON.parse(user.prenda) : ""
            const validateevidencias = isValidJsonArrayString(user.tipoDocumento) ? JSON.parse(user.tipoDocumento) : ""

            getProcesos();
            getTipoEvidencias();
            getPrendas();

            const EditForm = {
                "IdCicloEscolar": user.IdCicloEscolar === null ? 0 : user.IdCicloEscolar,
                "DescripcionCicloEscolar": user.Descripcion,
                "LinkVideoTutorial": user.LinkVideoTutorial,
                "Activo": user.Activo,
                "FechaIni": fechaInicioCiclo,
                "FechaFin": fechaFinCiclo,
                "CantidadEvidencias": user.CantidadEvidencias,
                "EntregaKit": user.EntregaKit,
                "TextoCiclo": user.TextoCiclo,
                "VigenciaCiclo": user.VigenciaCiclo,
                "LimitePrendas": user.LimitePrendas,
                "HabilitarEntregaParcial": user.HabilitarEntregaParcial,
                "Evento": user.Evento,
                "Visible": user.Visible,
                "proceso": validateproceso,
                "prendas": validateprendas,
                "evidencias": validateevidencias
            }
            setForm({ ...initialForm, ...EditForm });
            setInitialFormState({ ...initialForm, ...EditForm });
            // setErrors(validationsFrom(EditForm));
        } else {
        }
    }, [user]);

    const getProcesos = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultaProcesosListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                res.ITEMS.push({ idproceso: 0, proceso: "Otro" })
                setLstProcesos(res.ITEMS)
            }
        })
    }

    const getTipoEvidencias = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdTipoDocumentoListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                // let items = res.ITEMS.unshift({})
                setLstTipoEvidencias(res.ITEMS)
            }
        })
    }

    const getPrendas = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultaPrendaListar",
                opcion: 0,
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                res.ITEMS.push({ idprenda: 0, Prenda: "Otro" })
                setLstPrendas(res.ITEMS)
            }
        })
    }

    const handleSubmit = (e) => {

        if (formSinCambios()) {
            showToast('success', 'Mensaje:', 'Ciclo actualizado correctamente.');
            close();
            return;
        }
        
        e !== null || e !== undefined && e.preventDefault();
        setErrors(validationsFrom(form));
        if (Object.keys(validationsFrom(form)).length === 0) {
            if (form.FechaIni <= form.FechaFin) {
                const arrUser = {
                    "Opcion": "M",
                    "IdCicloEscolar": form.IdCicloEscolar,
                    "IdPerfil": perfil,
                    "IdUsuario": usuario,
                    "DescripcionCicloEscolar": form.DescripcionCicloEscolar,
                    "LinkVideoTutorial": form.LinkVideoTutorial,
                    "Activo": form.Activo,
                    "FechaInicioCiclo": form.FechaIni.toISOString().split('T')[0],
                    "FechaFinCiclo": form.FechaFin.toISOString().split('T')[0],
                    "cantidadevidencias": form.CantidadEvidencias,
                    "EntregaKit": form.EntregaKit,
                    "TextoCiclo": form.TextoCiclo,
                    "VigenciaCiclo": form.Vigencia,
                    "LimitePrendas": form.LimitePrendas,
                    "HabilitarEntregaParcial": form.HabilitarEntregaParcial,
                    "Evento": form.Evento,
                    "Visible": form.Visible,
                    "proceso": showInput ? JSON.stringify({ idproceso: 0, proceso: form.otroProceso }) : JSON.stringify(form.proceso),
                    "prendas": JSON.stringify(form.prendas),
                    "documentos": JSON.stringify(form.evidencias)

                };
                setLoading(true);
                helpHttp().post(`${BASE_API}Usuarios/SpdCrudCicloEscolar`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    },
                }).then(async (res) => {
                    if (res.SUCCESS) {
                        let getCiclo = await obtenerCiclo(form.IdCicloEscolar);
                        showToast('success', 'Mensaje:', 'Ciclo actualizado correctamente.');
                        close();
                        setShowInput(false)
                        onComponentUpdate(getCiclo);
                    } else {
                        showToast('warn', 'Mensaje:', res.MESSAGE);
                        setLoading(false);
                        //close();
                    }
                    setLoading(false);
                });
            } else {
                showToast('warn', 'Aviso:', 'Formato de fecha inválido.');
                return;
            }
        } else {
            showToast('warn', 'Aviso:', 'Favor de llenar los campos requeridos.');
            return;
        }
    };

    const obtenerCiclo = async (IdCicloEscolar) => {
        let ciclos = []
        const date = new Date();
        ciclos = await helpHttp().post(`${BASE_API}Usuarios/SpdCrudCicloEscolar`, {
            body: {
                "Opcion": "S",
                "IdCicloEscolar": null,
                "IdPerfil": perfil,
                "IdUsuario": usuario,
                "DescripcionCicloEscolar": "",
                "LinkVideoTutorial": "",
                "Activo": null,
                "FechaInicioCiclo": date.toISOString(),
                "FechaFinCiclo": date.toISOString(),
                "EntregaKit": null,
                "TextoCiclo": "",
                "VigenciaCiclo": "",
                "LimitePrendas": null,
                "HabilitarEntregaParcial": null,
                "Evento": null,
                "Visible": null
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS);

        let ciclo = ciclos.find(x => x.IdCicloEscolar === IdCicloEscolar)

        return ciclo;
    }

    const formatearFecha = (fecha = new Date()) => {
        const formato = fecha.toLocaleDateString('es-MX', {
            month: 'short',
            year: 'numeric'
        }).toUpperCase();

        return formato.includes('.') ? formato : formato.replace(/([A-Z]{3})/, '$1.');
    }

    const handleInputChange = (e) => {
        setForm({ ...form, otroProceso: e.target.value });
    };

    const handleDropdownChange = (e) => {
        const value = e.value;
        setForm({ ...form, proceso: value });

        if (value.idproceso === 0) {
            // Si elige "Otro", cambiamos a input
            setShowInput(true);
        } else {
            setShowInput(false);
        }
    };

    const handleClose = () => {
        // Al cerrar, regresamos al dropdown
        setShowInput(false);
        setForm({ ...form, proceso: null, otroProceso: "" });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm(prevForm => {
            let newForm = { ...prevForm };

            if (name === "LimitePrendas") {
                const newLimit = parseInt(value) || 1;
                newForm.LimitePrendas = newLimit;

                // Ajustar array de prendas
                if (!newForm.prendas) newForm.prendas = [""];

                if (newLimit > newForm.prendas.length) {
                    // Agregar nuevas prendas vacías
                    for (let i = newForm.prendas.length; i < newLimit; i++) {
                        newForm.prendas.push("");
                    }
                } else {
                    // Remover prendas sobrantes
                    newForm.prendas = newForm.prendas.slice(0, newLimit);
                }
            }

            if (name === "CantidadEvidencias") {
                const newLimit = parseInt(value) || 1;
                newForm.CantidadEvidencias = newLimit;

                // Ajustar array de evidencias
                if (!newForm.evidencias) newForm.evidencias = [""];

                if (newLimit > newForm.evidencias.length) {
                    // Agregar nuevas evidencias vacías
                    for (let i = newForm.evidencias.length; i < newLimit; i++) {
                        newForm.evidencias.push("");
                    }
                } else {
                    // Remover evidencias sobrantes
                    newForm.evidencias = newForm.evidencias.slice(0, newLimit);
                }
            } else {
                newForm[name] = value;
            }

            return newForm;
        });
    };

    // Manejar cambio individual de prenda
    const handlePrendaChange = (index, selectedObject) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];

            // Si selecciona "Otros", inicializar con el objeto completo
            if (selectedObject && selectedObject.id === 0) {
                newPrendas[index] = { ...selectedObject, Prenda: "" }; // Objeto con texto vacío
            } else {
                newPrendas[index] = selectedObject; // Objeto normal o string vacío
            }

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    const handleOtraPrendaInputChange = (index, textValue) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];

            // Actualizar el texto de la prenda personalizada
            if (newPrendas[index] && typeof newPrendas[index] === 'object') {
                newPrendas[index] = {
                    ...newPrendas[index],
                    Prenda: textValue
                };
            }

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    const handleCloseOtraPrenda = (index) => {
        setForm(prevForm => {
            const newPrendas = [...prevForm.prendas];
            newPrendas[index] = ""; // Limpiar la selección

            return {
                ...prevForm,
                prendas: newPrendas
            };
        });
    };

    // Manejar cambio individual de evidencia
    const handleEvidenciaChange = (index, selectedObject) => {
        setForm(prevForm => {
            const newEvidencias = [...prevForm.evidencias];

            if (selectedObject) {
                // Si ya existe una evidencia en este índice, mantener el estado 'activo'
                const currentActivo = newEvidencias[index]?.obligatorio !== false; // true por defecto
                let objDescripcion = lstTipoEvidencias.find(x => x.IdTipoDocumento === selectedObject)

                newEvidencias[index] = {
                    IdTipoDocumento: selectedObject,
                    TipoDocumento: objDescripcion.TipoDocumento,
                    obligatorio: currentActivo
                };
            } else {
                // Si se limpia la selección, limpiar todo
                newEvidencias[index] = "";
            }

            return {
                ...prevForm,
                evidencias: newEvidencias
            };
        });
    };

    const handleEvidenciaSwitchChange = (index, checked) => {
        setForm(prevForm => {
            const newEvidencias = [...prevForm.evidencias];

            // Solo actualizar la propiedad 'activo', mantener el resto del objeto intacto
            if (newEvidencias[index] && typeof newEvidencias[index] === 'object') {
                newEvidencias[index] = {
                    ...newEvidencias[index],
                    obligatorio: checked
                };
            }

            return {
                ...prevForm,
                evidencias: newEvidencias
            };
        });
    };

    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFrom(form));
    };

    const showToast = (severity, summary, detail) => {
        toast.current.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: 5000
        });
    };

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    const editarFooter = () => (
        <div className="text-right" style={{ marginTop: '7px', paddingTop: '7px' }}>
            <Button label="Cancelar" icon='pi pi-times' className="p-button-outlined mr-2 mb-2" onClick={() => {
                close();
                setShowInput(false);
            }} />
            <Button disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} label="Guardar" className="p-component mr-2 mb-2" onClick={() => handleSubmit()} />
        </div>
    );

    const formSinCambios = () => {
        if (!initialFormState) {
            return true;
        }
        else{
            return JSON.stringify(form) === JSON.stringify(initialFormState);
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog id="modalCambioCiclo" header="EDITAR CICLO" className='w-10 xl:w-6 lg:w-8 md:w-9' draggable={false} closable={false} blockScroll={true} visible={visible} footer={editarFooter} modal onHide={() => {
                close();
                setShowInput(false)
            }}>
                <form onSubmit={handleSubmit} className="col-12">
                    <div className="div">
                        <Tooltip target=".custom-target"/>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 text-right mb-0">
                                <label className='mb-0' style={{ color: 'red' }}>* Campos obligatorios</label>
                            </div>

                            <div className='col-12 mt-3 mb-2' style={{ fontWeight: '800' }}>
                                <h6 style={{color: '#9b2f3e'}}>DATOS GENERALES <i className='pi pi-info-circle custom-target' data-pr-position='right' data-pr-tooltip='Algunos campos puede estar deshabilitados si existen entregas'></i></h6>
                                <hr style={{  border: '1px solid black'}}></hr>
                            </div>

                            <div className="field col-12 lg:col-6 md:col-6">
                                <label htmlFor="DescripcionCicloEscolar"><label style={{ color: 'red' }}>*</label> Ciclo escolar</label>
                                <InputText disabled={!user?.ActualizarCiclo} id="DescripcionCicloEscolar" name="DescripcionCicloEscolar" type="text" value={form.DescripcionCicloEscolar} onChange={handleChange} className={errors.DescripcionCicloEscolar && 'p-invalid'}/>
                                {errors.DescripcionCicloEscolar && <small className="p-error">{errors.DescripcionCicloEscolar}</small>}
                            </div>
                            <div className="field col-12 lg:col-6 md:col-6">
                                <label htmlFor="usuario"><label style={{ color: 'red' }}>*</label> Proceso</label>
                                {!showInput ? (
                                    <Dropdown disabled={!user?.ActualizarCiclo} id="proceso" name="proceso" value={form?.proceso} optionLabel="proceso" options={lstProcesos} onChange={handleDropdownChange} placeholder="Selecciona" className="w-full" style={{ textTransform: 'uppercase' }} panelStyle={{ textTransform: 'uppercase' }} />
                                ) : (
                                    <span className="p-input-icon-right w-full">
                                        <i id='iconInputOtro' className="pi pi-times cursor-pointer text-gray-700 hover:text-orange-500" onClick={handleClose} />
                                        <InputText id="otroProceso" value={form.otroProceso} onChange={handleInputChange} placeholder="Especifica otro proceso" className="w-full" />
                                    </span>
                                )}
                                {errors.proceso && <small className="p-error">{errors.proceso}</small>}
                            </div>
                            <div className='field col-12 lg:col-3 md:col-3'>
                                <label htmlFor="FechaIni"><label style={{ color: 'red' }}>*</label> Fecha inicio</label>
                                <i className='pi pi-info-circle ml-2 custom-target' data-pr-tooltip='Fecha para vigencia del vale'></i>
                                <Calendar disabled={!user?.ActualizarCiclo} id='FechaIni' name='FechaIni' className={errors.FechaIni && 'p-invalid'} locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={form.FechaIni} onChange={handleChange}></Calendar>
                                {errors.FechaIni && <small className="p-error">{errors.FechaIni}</small>}
                            </div>
                            <div className='field col-12 lg:col-3 md:col-3'>
                                <label htmlFor="FechaFin"><label style={{ color: 'red' }}>*</label> Fecha fin</label>
                                <i className='pi pi-info-circle ml-2 custom-target' data-pr-tooltip='Fecha para vigencia del vale'></i>
                                <Calendar disabled={!user?.ActualizarCiclo} id='FechaFin' name='FechaFin' className={errors.FechaFin && 'p-invalid'} locale='es' dateFormat='dd/mm/yy' showIcon showButtonBar value={form.FechaFin} onChange={handleChange}></Calendar>
                                {errors.FechaFin && <small className="p-error">{errors.FechaFin}</small>}
                            </div>

                            <div className="field col-12 lg:col-6 md:col-6">
                                <label htmlFor="LinkVideoTutorial">Link de videotutorial (carga de evidencias)</label>
                                <InputText autoFocus id="LinkVideoTutorial" name="LinkVideoTutorial" type="text" value={form.LinkVideoTutorial} onChange={handleChange} className={errors.LinkVideoTutorial && 'p-invalid'}/>
                                {errors.LinkVideoTutorial && <small className="p-error">{errors.LinkVideoTutorial}</small>}
                            </div>

                            <div className="field col-6">
                                <div className='flex col-12 mb-2'>
                                    <InputSwitch disabled={!user?.ActualizarCiclo} id='estilodeSwitc' className='mr-2' name='HabilitarEntregaParcial' checked={form.HabilitarEntregaParcial} onChange={handleChange} />
                                    <label htmlFor="HabilitarEntregaParcial">Entrega parcial</label>
                                </div>
                                <div className='flex col-12 mb-2'>
                                    <InputSwitch disabled={!user?.ActualizarCiclo} id='estilodeSwitc' className='mr-2' name='EntregaKit' checked={form.EntregaKit} onChange={handleChange} />
                                    <label htmlFor="EntregaKit">Entrega kit</label>
                                </div>
                            </div>

                            <div className="field col-6">
                                <div className="flex col-12 mb-2">
                                    <InputSwitch disabled={!user?.ActualizarCiclo} id='estilodeSwitc' className='mr-2' name='Evento' checked={form.Evento} onChange={handleChange} />
                                    <label htmlFor="Evento">Habrá sede</label>
                                </div>
                                <div className="flex col-12 mb-2">
                                    <InputSwitch id='estilodeSwitc' className='mr-2' name='Visible' checked={form.Visible} onChange={handleChange} />
                                    <label htmlFor="Visible">Visible director</label>
                                </div>
                            </div>

                            <div className='col-12 mt-6 mb-2' style={{ fontWeight: '800' }}>
                                <h6 style={{color: '#9b2f3e'}}>PRENDAS</h6>
                                <hr style={{  border: '1px solid black'}}></hr>
                            </div>

                            <div className="field col-12 lg:col-6 md:col-6">
                                <label htmlFor="LimitePrendas"><label style={{ color: 'red' }}>*</label> Prendas en catálogo</label>
                                {/* <InputText id="nombre" disabled={(form.tipo_usuario == 13 || form.tipo_usuario == 16) && form.usuario.substring(0, 2) == 26 ? true : false} name="nombre" type="text" value={form.nombre} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} /> */}
                                <InputNumber disabled={!user?.ActualizarCiclo} id='LimitePrendas' name='LimitePrendas' value={form.LimitePrendas} onValueChange={handleChange} className={errors.LimitePrendas && 'p-invalid'} mode="decimal" showButtons min={1} />
                                {errors.LimitePrendas && <small className="p-error">{errors.LimitePrendas}</small>}
                            </div>
                            <>
                                {Array.from({ length: form.LimitePrendas }, (_, i) => (
                                    <div key={`prenda-${i}`} className="field col-12 lg:col-3 md:col-6">
                                        <label htmlFor={`prenda-${i}`}>
                                            <label style={{ color: 'red' }}>*</label> Prenda {i + 1}:
                                        </label>

                                        {!form.prendas[i] || (form.prendas[i] && form.prendas[i].idprenda !== 0) ? (
                                            // Dropdown normal
                                            <Dropdown
                                                disabled={!user?.ActualizarCiclo}
                                                id={`prenda-${i}`}
                                                value={form?.prendas[i] || ""}
                                                options={lstPrendas}
                                                optionLabel="Prenda"
                                                placeholder="Selecciona"
                                                emptyMessage='Opciones no disponibles'
                                                className={errors[`prenda-${i}`] && 'p-invalid'}
                                                onChange={(e) => {
                                                    const selected = e.value
                                                    if (selected.idprenda === 0) {
                                                        handlePrendaChange(i, { idprenda: 0, Prenda: "" })
                                                    } else {
                                                        handlePrendaChange(i, selected)

                                                    }
                                                }} style={{ textTransform: 'uppercase' }}
                                                panelStyle={{ textTransform: 'uppercase' }}
                                            />
                                        ) : (
                                            // InputText para "Otros"
                                            <span className="p-input-icon-right w-full">
                                                <i id='iconInputOtro' className="pi pi-times cursor-pointer text-gray-700 hover:text-orange-500" onClick={() => handleCloseOtraPrenda(i)} />
                                                <InputText
                                                    disabled={!user?.ActualizarCiclo}
                                                    id={`prenda-${i}-input`}
                                                    value={form.prendas[i]?.Prenda || ""}
                                                    placeholder="Especifica otra prenda"
                                                    className={"w-full"}
                                                    onChange={(e) => handleOtraPrendaInputChange(i, e.target.value)}
                                                />
                                            </span>
                                        )}

                                        {errors[`prenda-${i}`] && <small className="p-error">{errors[`prenda-${i}`]}</small>}
                                    </div>
                                ))}
                            </>

                            <div className='col-12 mt-6 mb-2' style={{ fontWeight: '800' }}>
                                <h6 style={{color: '#9b2f3e'}}>EVIDENCIAS</h6>
                                <hr style={{  border: '1px solid black'}}></hr>
                            </div>

                            <div className="field col-12 lg:col-6 md:col-6">
                                <label htmlFor="CantidadEvidencias"><label style={{ color: 'red' }}>*</label> Cantidad de evidencias</label>
                                {/* <InputText id="nombre" disabled={(form.tipo_usuario == 13 || form.tipo_usuario == 16) && form.usuario.substring(0, 2) == 26 ? true : false} name="nombre" type="text" value={form.nombre} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} /> */}
                                <InputNumber disabled={!user?.ActualizarCiclo} id='CantidadEvidencias' name='CantidadEvidencias' value={form.CantidadEvidencias} onValueChange={handleChange} className={errors.CantidadEvidencias && 'p-invalid'} mode="decimal" showButtons min={1} max={4} />
                                {errors.CantidadEvidencias && <small className="p-error">{errors.CantidadEvidencias}</small>}
                            </div>
                            <>
                                {Array.from({ length: form.CantidadEvidencias || 0 }, (_, i) => (
                                    <div key={`evidencia-${i}`} className="field col-12 lg:col-3 md:col-6 sm:col-12">
                                        <div className="flex flex-column">
                                            <label htmlFor={`evidencia-${i}`}>
                                                <label style={{ color: 'red' }}>*</label> Evidencia {i + 1}:
                                            </label>

                                            {/* Dropdown - mostrar siempre la evidencia seleccionada aunque esté inactiva */}
                                            <Dropdown
                                                disabled={!user?.ActualizarCiclo}
                                                id={`evidencia-${i}`}
                                                value={form.evidencias[i]?.IdTipoDocumento || ""}
                                                options={lstTipoEvidencias}
                                                optionLabel="TipoDocumento"
                                                optionValue="IdTipoDocumento"
                                                placeholder="Selecciona evidencia"
                                                emptyMessage="Opciones no disponibles"
                                                className={errors[`evidencia-${i}`] && 'p-invalid'}
                                                onChange={(e) => handleEvidenciaChange(i, e.value)}
                                                style={{ width: '100%', marginBottom: '0.5rem', textTransform: 'uppercase' }}
                                                panelStyle={{ textTransform: 'uppercase' }}
                                            />

                                            {/* InputSwitch - solo controla el estado activo/inactivo */}
                                            <div className="flex align-items-center justify-content-start mt-2">
                                                <InputSwitch
                                                    disabled={!user?.ActualizarCiclo}
                                                    id={`switch-evidencia-${i}`}
                                                    className='estilodeSwitc'
                                                    checked={form.evidencias[i]?.obligatorio === true}
                                                    onChange={(e) => handleEvidenciaSwitchChange(i, e.value)}
                                                    //disabled={!form.evidencias[i]} // Solo deshabilitar si no hay evidencia seleccionada
                                                />
                                                <label htmlFor={`switch-evidencia-${i}`} className="ml-2" style={{ color: '#5e5e5eff' }}>Obligatorio</label>
                                            </div>

                                            {errors[`evidencia-${i}`] && <small className="p-error">{errors[`evidencia-${i}`]}</small>}
                                        </div>
                                    </div>
                                ))}
                            </>





                            {/* <div className="field col-12">
                                <label htmlFor="password_">Contraseña:</label>
                                <Password id="password" toggleMask feedback={false} name="password" type="password" value={form.password} onChange={handleChange} onBlur={handleBlur} className={errors.password_ && 'p-invalid'} />
                                {errors.password_ && <small className="p-error">{errors.password_}</small>}
                            </div> */}
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    );
}

export default Edit;